<template>
  <div class="feedbackbody">
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>

    <div class="feekbox">
      <div class="feekmain001">
        <div class="feeksmbox">请选择反馈问题的类型</div>
        <div class="feekxzbox">
          <van-row>
            <van-col span="12">
              <van-checkbox v-model="checked.ck01" checked-color="#ffbd0a">
                <em>视频上传不了</em>
              </van-checkbox>
            </van-col>
            <van-col span="12">
              <van-checkbox v-model="checked.ck02" checked-color="#ffbd0a">
                <em>打开速度很慢</em>
              </van-checkbox>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="12">
              <van-checkbox v-model="checked.ck03" checked-color="#ffbd0a">
                <em>填写资料不能提交</em>
              </van-checkbox>
            </van-col>
            <van-col span="12">
              <van-checkbox v-model="checked.ck04" checked-color="#ffbd0a">
                <em>页面白屏</em>
              </van-checkbox>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="12">
              <van-checkbox v-model="checked.ck05" checked-color="#ffbd0a">
                <em>会员问题</em>
              </van-checkbox>
            </van-col>
            <van-col span="12">
              <van-checkbox v-model="checked.ck06" checked-color="#ffbd0a">
                <em>其他问题</em>
              </van-checkbox>
            </van-col>
          </van-row>
        </div>
      </div>

      <div class="feekmain002">
        <div class="feeksmbox">问题和意见</div>
        <div class="feekupimgbox">
          <div class="feekupsm">
            <textarea name="errmsg" v-model="errmsg" placeholder="请描述您遇到的问题和建议，若功能异常，上传页面截图能更快解决问题哦！"></textarea>
          </div>
          <div class="uploaderbox">
            <van-uploader v-model="fileList" :after-read="afterRead" multiple :max-count="4" />
          </div>
        </div>
      </div>

      <div class="feekmain003">
        <div class="feeksmbox">联系方式</div>
        <div class="cu-form-group">
          <input placeholder="请填写您的手机号" v-model="telphone" placeholder-style="font-size:0.7027027027027027rem ;color:#999;" name="telphone" />
        </div>
      </div>

      <div class="buttonbox">
        <button class="savetobtn" form-type="submit" @click="formSubmit">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getfeedback } from "../../api/api";
import navbar from "../public/navbar.vue";
import { mapState } from 'vuex';
import Vue from "vue";
import { Toast } from "vant";

// 全局注册
Vue.use(Toast);

export default {
  name: "feedback",
  components: { navbar },
  data () {
    return {
      titlename: "意见反馈",
      checked: {
        ck01: false,
        ck02: false,
        ck03: false,
        ck04: false,
        ck05: false,
        ck06: false
      },
      fileList: [],
      telphone: "",
      errmsg: "",
      errpic: ""
    };
  },
  computed: {
    ...mapState(["baseAPI"])
  },
  created () {
    document.title = '意见反馈';
  },
  methods: {
    afterRead (file) {
      var that = this;
      // 此时可以自行将文件上传至服务器
      var type = Object.prototype.toString.call(file);
      var fileList = [];

      if (type == "[object Object]") {
        fileList.push(file);
      } else {
        fileList = file;
      }
      fileList.filter(item => {
        var base64String = item.content;
        //这里对base64串进行操作，去掉url头，并转换为byte
        var bytes = window.atob(base64String.split(",")[1]);

        //处理异常，将ASCII码小于0的转换为大于0，这里有两种写法

        var ab = new ArrayBuffer(bytes.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < bytes.length; i++) {
          ia[i] = bytes.charCodeAt(i); //这里有点疑惑，ia是怎么改变ab的？注：①
        }
        //Blob对象
        var blob = new Blob([ab], { type: "image/jpeg" }); //type为图片的格式

        //FormData对象
        var formData = new FormData();

        formData.append("file", blob, Date.now() + ".jpg");

        let that = this;

        const baseURL = this.baseAPI;

        //上传
        const instance = axios.create({
          withCredentials: false
        });
        axios.defaults.headers.common["PLATFORM"] = "H5";
        instance
          .post(baseURL + "/file-bases/images", formData)
          .then(res => {
            that.errpic = that.errpic + res.data.data.url + ',';
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    },
    formSubmit: function () {
      let checked = this.checked;
      let question = "";
      Object.keys(checked).forEach(function (key, index) {
        if (checked[key]) {
          question = String(index + 1) + "," + question;
        }
      });
      question = question.substr(0, question.length - 1);
      let fb_type = "0";
      let other_no = this.telphone;
      let err_msg = this.errmsg;
      let err_pic = this.errpic.substr(0, this.errpic.length - 1);
      let json = {
        question: question,
        fb_type: fb_type,
        other_no: other_no,
        err_msg: err_msg,
        err_pic: err_pic
      };
      if (!this.reMobile(other_no)) {
        Toast({
          duration: 2000,
          message: "请正确填写手机号码！"
        });
        return;
      }
      if (question.length == 0 && err_msg == "") {
        Toast({
          duration: 2000,
          message: "请填写反馈信息！"
        });
        return;
      }
      var that = this;
      getfeedback(json)
        .then(res => {
          if (res.code == 200) {
            Toast.success({
              duration: 1000,
              message: "提交成功！",
              onClose: function () {
                that.$router.go(-1);
              }
            });
          } else {
            Toast.fail({
              duration: 2000,
              message: "提交失败！"
            });
          }
        })
        .catch(err => {
        });
    },
    //验证手机号
    reMobile: function (mobile) {
      let regStr = /^0?(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      return regStr.test(mobile);
    }
  }
};
</script>

<style>
.feekbox {
  padding-top: 50px;
}
.feekbox .feekmain001 {
  background: #fff;
  padding-bottom: 0.8rem;
}
.feekbox .feekmain001 .feeksmbox {
  line-height: 1.8rem;
  color: #999;
  height: 1.8rem;
  border-bottom: 1px solid #efefef;
  font-size: 0.64rem;
  padding-left: 0.68rem;
}
.feekbox .feekxzbox {
  padding-top: 0.5rem;
}
.feekbox .feekxzbox .van-row {
  padding: 0.4rem;
}
.feekbox .feekxzbox .van-row .van-checkbox span.van-checkbox__label em {
  font-size: 0.72rem;
  padding-left: 0.2rem;
  font-style: normal;
  color: #333;
}
.van-checkbox__icon {
  height: 1.2rem;
  line-height: 1.2rem;
}
.van-checkbox__icon .van-icon {
  width: 1.1rem;
  height: 1.1rem;
  line-height: 1.2rem;
  /* margin-top: 0.1rem; */
}
.van-checkbox__label {
  margin-top: -0.2rem;
}
.van-col {
  padding-left: 1.1rem;
  padding-right: 0.25rem;
}

.feekbox .feekmain002 {
  background: #fff;
  margin-top: 0.40540540540540543rem;
  padding-bottom: 20px;
  margin-top: 0.4rem;
}
.feekbox .feekmain002 .feeksmbox {
  line-height: 1.8rem;
  color: #999;
  height: 1.8rem;
  border-bottom: 1px solid #efefef;
  font-size: 0.64rem;
  padding-left: 0.68rem;
}

.feekbox .feekmain002 .feekupsm {
  color: #999;
  padding-left: 0.6rem;
  padding-right: 0.8rem;
  font-size: 0.7567567567567568rem;
  padding-top: 0.6rem;
  line-height: 1.1rem;
}
.feekbox .feekmain002 .feekupsm textarea {
  width: 100%;
  height: 3.7rem;
  border: none;
  font-size: 0.72rem;
  color: #666;
  line-height: 1.2162162162162162rem;
}

.feedbackbody {
  height: 100%;
  background: #f8f8f8;
}

.feekbox .feekmain002 .feekupimgbox .uploaderbox {
  padding-left: 0.6rem;
}
.feekbox .feekmain002 .feekupimgbox .uploaderbox .van-uploader__preview {
  margin-right: 0.55rem;
}

.feekbox .feekmain002 .feekupimgbox .uploaderbox .van-uploader__preview-image {
  border-radius: 3px;
  overflow: hidden;
}
.feekbox .feekmain002 .feekupimgbox .uploaderbox .van-uploader__upload {
  border: 1px solid #d8d8d8;
  border-radius: 10px;
  overflow: hidden;
}
.feekbox .feekmain002 .feekupimgbox .uploaderbox .van-uploader__preview-delete {
  border-radius: 0 0 10px 0;
}

.feekbox .feekmain003 {
  background: #fff;
  margin-top: 0.4rem;
  padding-bottom: 0.64rem;
}
.feekbox .feekmain003 .feeksmbox {
  line-height: 1.9rem;
  color: #999;
  height: 1.8rem;
  border-bottom: 1px solid #efefef;
  font-size: 0.64rem;
  padding-left: 0.68rem;
}
.feekbox .feekmain003 .cu-form-group {
  border-bottom: 1px solid #eee;
  margin-left: 0.64rem;
  margin-right: 0.64rem;
}
.feekbox .feekmain003 .cu-form-group input {
  font-size: 0.75rem;
  border: none;
  line-height: 2.88rem;
}

.feekbox .buttonbox {
  /* padding-bottom: 0.8rem; */
  padding-top: 0.8rem;
  /*   background: #fff; */
  text-align: center;
  /* bottom: 0;
  position: fixed; */
  width: 100%;
}
.feekbox .buttonbox .savetobtn {
  height: 2.4rem;
  font-size: 0.74rem;
  color: #ffffff;
  line-height: 2.4rem;
  border-radius: 1.33rem;
  border: none;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  width: 90%;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/feedback.vue